import { z } from 'zod';

import { labelSearchField } from '@/features/labels';
import { TASK_TABS } from '@/features/tasks';

/*
  The Tasks page's address.

  Every list parameter is plain text here and given meaning by `listViewOf`
  (spec 112), which drops what it does not recognise — a shared link outlives
  the vocabulary it was written in, and a whole-route validation failure over
  one stale value would be the worst answer to it. `state` in particular is a
  comma list now, and a single old value is simply a list of one.
*/
/*
  Text, whatever the router made of it. The router parses search values as
  JSON, so `?hidden=1` arrives as the number 1 and `?q=2026` as a number too —
  a string-only field would silently drop both. Numbers and booleans are taken
  back to text here and given meaning by `listViewOf`.
*/
const text = z
  .union([z.string(), z.number(), z.boolean()])
  .transform((value) => String(value))
  .optional()
  .catch(undefined);

export const workspaceTasksSearchSchema = z.object({
  q: text,
  labels: labelSearchField,
  state: text,
  workflow: text,
  assignee: text,
  creator: text,
  since: text,
  on: text,
  hidden: text,
  sort: text,
  dir: text,
  // The open drawer (spec 111), under the board's own names and validators, so
  // `?task=…&tab=…` means one thing on both pages. `tab` has no default for the
  // board's reason: absent, the drawer picks its landing tab and writes it back.
  task: z.uuid().optional().catch(undefined),
  tab: z.enum(TASK_TABS).optional().catch(undefined),
  // Which workspace file is shown beside the open task. Meaningless without
  // `task` and stripped when the drawer closes, exactly as `tab` is.
  preview: z.string().optional().catch(undefined),
});

export type WorkspaceTasksSearch = z.infer<typeof workspaceTasksSearchSchema>;
